export const UnsavedChangesStoresKey = 'stores';
